import React, { useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";


/**
 * Rich Text Editor using React-Quill
 * - parent stores `blogs.content` as HTML
 * - viewer page renders blog content as HTML
 */
const BlogTiptapEditor = ({ valueHtml = "", onChangeHtml }) => {
  const modules = useMemo(
    () => ({
      toolbar: [
        // Text formatting
        ["bold", "italic", "underline", "strike"],

        // Heading levels
        [{ header: [1, 2, 3, false] }],

        // Lists
        [{ list: "ordered" }, { list: "bullet" }],

        // Color and background
        [{ color: [] }, { background: [] }],

        // Text align
        [{ align: [] }],

        // Blockquote and code block
        ["blockquote", "code-block"],

        // Link and image
        ["link", "image"],

        // Clear formatting
        ["clean"],
      ],
    }),
    []
  );

  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "header",
    "list",
    "bullet",
    "ordered",
    "color",
    "background",
    "align",
    "blockquote",
    "code-block",
    "link",
    "image"
  ];

  return (
    <div className="blog-rich-editor-wrapper">
      <div className="blog-rich-editor-card">
        <ReactQuill
          theme="snow"
          style={{ height: "100%" }}
          value={valueHtml}
          onChange={(html) => onChangeHtml?.(html)}
          modules={modules}
          formats={formats}
          placeholder="Write your blog content..."
          className="blog-rich-editor"
        />
      </div>
    </div>
  );
};

export default BlogTiptapEditor;